import { Box, Skeleton, Typography } from '@mui/material';
import { SelectPlatform } from 'components/common';
import { SelectAdAccounts } from './FacebookFormComponents';
import type { FC } from 'react';
import { Suspense, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useLocationParams } from 'hooks';
import type { Platform } from '../../../constants';

const EMPTY_AD_ACCOUNTS: string[] = [];

const AdAccountsForm: FC = () => {
  const { trigger, getFieldState, watch } = useFormContext();
  const isDirty = getFieldState('adAccounts').isDirty;
  const platform = watch('platform') as string | undefined;
  const adAccounts =
    (watch('adAccounts') as string[] | undefined) ?? EMPTY_AD_ACCOUNTS;

  const { setPlatform: setPlatformParam, setAdAccounts: setAdAccountsParam } =
    useLocationParams();

  useEffect(() => {
    if (isDirty)
      void trigger('adAccounts');
  }, [trigger, isDirty]);

  // Mirrors the step's selections to the URL so a reload/deep-link restores
  // the same platform + ad accounts. Each setter is a no-op when its value
  // hasn't changed.
  useEffect(() => {
    if (!platform) return;
    setPlatformParam(platform as Platform);
  }, [platform, setPlatformParam]);

  useEffect(() => {
    setAdAccountsParam(adAccounts);
  }, [adAccounts, setAdAccountsParam]);

  return (
    <>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Ad Accounts & Platform
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          maxWidth: '50%',
          width: '100%',
        }}
      >
        <SelectPlatform />
        <Suspense fallback={
          <Skeleton
            height={40}
            sx={{ transform: 'translateY(0)', borderRadius: '8px' }}
          />
        }>
          <SelectAdAccounts />
        </Suspense>
      </Box>
    </>
  );
};
export default AdAccountsForm;
